(function() {
  'use strict';

  // ═══════════════════════════════════════════════════
  // PAGE LOADER — brand-signature "veyl." entrance
  // ═══════════════════════════════════════════════════
  function initLoader(onComplete) {
    var loader = document.createElement('div');
    loader.id = 'veyl-loader';
    loader.innerHTML = '<div style="display:flex;flex-direction:column;align-items:center;gap:16px">' +
      '<div class="loader-logo" style="font-family:Hanken Grotesk,sans-serif;font-size:clamp(24px,4vw,48px);font-weight:500;letter-spacing:-0.02em;color:var(--primary);opacity:0;transform:translateY(10px)">veyl.</div>' +
      '<div class="loader-line" style="width:0;height:1px;background:var(--primary);opacity:0.4"></div></div>';
    loader.style.cssText = 'position:fixed;inset:0;z-index:999999;background:var(--bg);display:flex;align-items:center;justify-content:center;';
    document.body.prepend(loader);
    document.body.style.overflow = 'hidden';

    if (typeof gsap !== 'undefined') {
      var logo = loader.querySelector('.loader-logo');
      var line = loader.querySelector('.loader-line');
      var tl = gsap.timeline();
      tl.to(logo, { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out', delay: 0.1 })
        .to(line, { width: '80px', duration: 0.8, ease: 'power2.inOut' }, '-=0.3')
        .to(line, { width: '0px', opacity: 0, duration: 0.4, ease: 'power2.in' }, '+=0.3')
        .to(logo, { opacity: 0, y: -10, duration: 0.3, ease: 'power2.in' }, '-=0.2')
        .to(loader, { opacity: 0, duration: 0.4, ease: 'power2.out', onComplete: function() {
          loader.remove();
          document.body.style.overflow = '';
          if (onComplete) onComplete();
        }});
    } else {
      setTimeout(function() {
        loader.remove();
        document.body.style.overflow = '';
        if (onComplete) onComplete();
      }, 800);
    }
  }

  // ═══════════════════════════════════════════════════
  // SCROLL REVEALS
  // ═══════════════════════════════════════════════════
  function initReveals() {
    if (typeof gsap === 'undefined') return;

    document.querySelectorAll('.reveal').forEach(function(el) {
      gsap.to(el, {
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' },
        opacity: 1, y: 0, duration: 1.2, ease: 'power3.out'
      });
    });

    document.querySelectorAll('.reveal-left').forEach(function(el) {
      gsap.to(el, {
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' },
        opacity: 1, x: 0, duration: 1.4, ease: 'power3.out'
      });
    });

    document.querySelectorAll('.reveal-right').forEach(function(el) {
      gsap.to(el, {
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' },
        opacity: 1, x: 0, duration: 1.4, ease: 'power3.out'
      });
    });

    document.querySelectorAll('.reveal-scale').forEach(function(el) {
      gsap.to(el, {
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' },
        opacity: 1, scale: 1, duration: 1.2, ease: 'power3.out'
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // 3D SPLIT TEXT — [data-split]
  // ═══════════════════════════════════════════════════
  function initSplitText() {
    if (typeof gsap === 'undefined') return;

    document.querySelectorAll('[data-split]').forEach(function(el) {
      var text = el.textContent || '';
      var words = text.trim().split(/\s+/);
      el.style.perspective = '1000px';
      el.innerHTML = words.map(function(w) {
        return '<span style="display:inline-block;overflow:hidden;vertical-align:bottom;perspective:800px;padding-bottom:0.15em">' +
          '<span class="split-word" style="display:inline-block;transform:translateY(120%) rotateX(-80deg);transform-origin:top center;opacity:0">' + w + '</span></span>';
      }).join(' ');

      var inner = el.querySelectorAll('.split-word');
      var delay = el.getAttribute('data-split-delay') || '0';

      gsap.to(inner, {
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          toggleActions: 'play none none none'
        },
        y: '0%',
        rotateX: 0,
        opacity: 1,
        duration: 1.2,
        stagger: 0.07,
        delay: parseFloat(delay),
        ease: 'power4.out'
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // 3D CLIP REVEALS — [data-clip]
  // ═══════════════════════════════════════════════════
  function initClipReveals() {
    if (typeof gsap === 'undefined') return;

    var fromVars = {
      bottom: { clipPath: 'inset(100% 0 0 0)', rotateX: 8, scale: 1.08, z: -60 },
      left:   { clipPath: 'inset(0 100% 0 0)', rotateY: -12, scale: 1.05, z: -40 },
      right:  { clipPath: 'inset(0 0 0 100%)', rotateY: 12, scale: 1.05, z: -40 }
    };

    document.querySelectorAll('[data-clip]').forEach(function(el) {
      var dir = el.getAttribute('data-clip') || 'bottom';

      if (el.parentElement) {
        el.parentElement.style.perspective = '1200px';
      }

      var from = fromVars[dir] || fromVars.bottom;
      gsap.set(el, {
        clipPath: from.clipPath,
        rotateX: from.rotateX || 0,
        rotateY: from.rotateY || 0,
        scale: from.scale,
        z: from.z,
        transformOrigin: 'center center',
        opacity: 0.3
      });

      gsap.to(el, {
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        clipPath: 'inset(0% 0% 0% 0%)',
        rotateX: 0,
        rotateY: 0,
        scale: 1,
        z: 0,
        opacity: 1,
        duration: 1.6,
        ease: 'power3.out'
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // 3D CARD TILT — [data-tilt]
  // ═══════════════════════════════════════════════════
  function init3DTilt() {
    if (typeof gsap === 'undefined' || 'ontouchstart' in window) return;

    document.querySelectorAll('[data-tilt]').forEach(function(el) {
      var card = el;
      var intensity = parseFloat(card.getAttribute('data-tilt') || '12');
      card.style.transformStyle = 'preserve-3d';
      card.style.transition = 'transform 0.1s ease';

      var shine = document.createElement('div');
      shine.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:2;opacity:0;transition:opacity 0.5s;' +
        'background:linear-gradient(135deg,rgba(255,255,255,0.1) 0%,transparent 50%,transparent 100%);';
      card.style.position = 'relative';
      card.style.overflow = 'hidden';
      card.appendChild(shine);

      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        var centerY = rect.top + rect.height / 2;
        var rotateY = ((e.clientX - centerX) / (rect.width / 2)) * intensity;
        var rotateX = -((e.clientY - centerY) / (rect.height / 2)) * intensity;

        gsap.to(card, {
          rotateX: rotateX,
          rotateY: rotateY,
          z: 20,
          duration: 0.4,
          ease: 'power2.out',
          transformPerspective: 1000
        });
        shine.style.opacity = '1';
        var shineX = ((e.clientX - rect.left) / rect.width) * 100;
        var shineY = ((e.clientY - rect.top) / rect.height) * 100;
        shine.style.background = 'radial-gradient(circle at ' + shineX + '% ' + shineY + '%, rgba(255,255,255,0.08) 0%, transparent 60%)';
      });

      card.addEventListener('mouseleave', function() {
        gsap.to(card, {
          rotateX: 0, rotateY: 0, z: 0,
          duration: 0.8, ease: 'elastic.out(1, 0.5)',
          transformPerspective: 1000
        });
        shine.style.opacity = '0';
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // 3D SCROLL DEPTH — [data-depth]
  // ═══════════════════════════════════════════════════
  function init3DScrollDepth() {
    if (typeof gsap === 'undefined') return;

    document.querySelectorAll('[data-depth]').forEach(function(el) {
      var depth = parseFloat(el.getAttribute('data-depth') || '1');
      var speed = depth * 50;

      gsap.to(el, {
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.5
        },
        y: -speed,
        ease: 'none'
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // 3D SECTION PERSPECTIVE — [data-perspective]
  // ═══════════════════════════════════════════════════
  function init3DSections() {
    if (typeof gsap === 'undefined') return;

    document.querySelectorAll('[data-perspective]').forEach(function(el) {
      el.style.transformStyle = 'preserve-3d';
      el.classList.remove('reveal', 'reveal-left', 'reveal-right', 'reveal-scale');
      el.style.opacity = '1';
      el.style.transform = 'none';

      gsap.to(el, {
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.5
        },
        rotateX: 2,
        z: 0,
        transformPerspective: 2000,
        transformOrigin: 'center center',
        ease: 'none'
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // MAGNETIC HOVER — [data-magnetic]
  // ═══════════════════════════════════════════════════
  function initMagnetic() {
    if (typeof gsap === 'undefined' || 'ontouchstart' in window) return;

    document.querySelectorAll('[data-magnetic]').forEach(function(el) {
      var btn = el;
      var strength = parseFloat(btn.getAttribute('data-magnetic') || '0.35');

      btn.addEventListener('mousemove', function(e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        gsap.to(btn, {
          x: x * strength,
          y: y * strength,
          rotateX: -y * 0.08,
          rotateY: x * 0.08,
          duration: 0.4,
          ease: 'power2.out',
          transformPerspective: 800
        });
      });

      btn.addEventListener('mouseleave', function() {
        gsap.to(btn, {
          x: 0, y: 0, rotateX: 0, rotateY: 0,
          duration: 0.7, ease: 'elastic.out(1, 0.4)'
        });
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // CUSTOM CURSOR
  // ═══════════════════════════════════════════════════
  function initCursor() {
    if ('ontouchstart' in window || window.innerWidth < 768) return;
    if (typeof gsap === 'undefined') return;

    var dot = document.createElement('div');
    dot.className = 'veyl-cursor';
    document.body.appendChild(dot);

    var ring = document.createElement('div');
    ring.className = 'veyl-cursor-ring';
    document.body.appendChild(ring);

    var mx = 0, my = 0;

    document.addEventListener('mousemove', function(e) {
      mx = e.clientX;
      my = e.clientY;
    });

    function tick() {
      gsap.set(dot, { x: mx, y: my });
      gsap.to(ring, { x: mx, y: my, duration: 0.15, ease: 'power2.out' });
      requestAnimationFrame(tick);
    }
    tick();

    var interactives = 'a, button, [data-magnetic], input, select, textarea, .cursor-pointer';

    document.querySelectorAll(interactives).forEach(function(el) {
      el.addEventListener('mouseenter', function() {
        dot.classList.add('active');
        ring.classList.add('active');
      });
      el.addEventListener('mouseleave', function() {
        dot.classList.remove('active');
        ring.classList.remove('active');
      });
    });

    document.addEventListener('mouseleave', function() {
      dot.style.opacity = '0';
      ring.style.opacity = '0';
    });
    document.addEventListener('mouseenter', function() {
      dot.style.opacity = '1';
      ring.style.opacity = '1';
    });
  }

  // ═══════════════════════════════════════════════════
  // NAV ENTRANCE
  // ═══════════════════════════════════════════════════
  function initNavEntrance() {
    if (typeof gsap === 'undefined') return;

    var navLinks = document.querySelectorAll('[data-nav-link]');
    if (navLinks.length === 0) return;

    gsap.from(navLinks, {
      opacity: 0,
      y: -20,
      rotateX: -40,
      duration: 0.8,
      stagger: 0.1,
      delay: 0.5,
      ease: 'power3.out',
      transformPerspective: 600
    });
  }

  // ═══════════════════════════════════════════════════
  // TEXT SCRAMBLE — [data-scramble]
  // ═══════════════════════════════════════════════════
  function initTextScramble() {
    document.querySelectorAll('[data-scramble]').forEach(function(el) {
      var original = el.textContent || '';
      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789—./';
      var frame = 0;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(el);

          var scramble = function() {
            frame++;
            el.textContent = original.split('').map(function(c, i) {
              if (c === ' ') return ' ';
              if (i < frame / 2) return original[i];
              return chars[Math.floor(Math.random() * chars.length)];
            }).join('');
            if (frame < original.length * 2) {
              requestAnimationFrame(scramble);
            } else {
              el.textContent = original;
            }
          };
          scramble();
        });
      }, { threshold: 0.5 });

      observer.observe(el);
    });
  }

  // ═══════════════════════════════════════════════════
  // TEXT SLIDES — [data-slide-left], [data-slide-right]
  // ═══════════════════════════════════════════════════
  function initTextSlides() {
    if (typeof gsap === 'undefined') return;

    document.querySelectorAll('[data-slide-left]').forEach(function(el) {
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' },
        x: -80, rotateY: 15, opacity: 0, duration: 1.2, ease: 'power3.out',
        transformPerspective: 800
      });
    });

    document.querySelectorAll('[data-slide-right]').forEach(function(el) {
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' },
        x: 80, rotateY: -15, opacity: 0, duration: 1.2, ease: 'power3.out',
        transformPerspective: 800
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // IMAGE HOVER — [data-hover-tint]
  // ═══════════════════════════════════════════════════
  function initImageHover() {
    document.querySelectorAll('[data-hover-tint]').forEach(function(el) {
      el.style.transition = 'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)';
      el.style.transformStyle = 'preserve-3d';

      el.addEventListener('mouseenter', function() {
        el.style.transform = 'scale(1.03) translateZ(20px)';
      });
      el.addEventListener('mouseleave', function() {
        el.style.transform = 'scale(1) translateZ(0)';
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // SVG SCENES — [data-svg-scene]
  // ═══════════════════════════════════════════════════

  // GRID SVG — wireframe grid with dots and label
  var GRID_SVG = '<svg viewBox="0 0 800 200" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full" style="overflow:visible">' +
    '<g class="grid-lines" opacity="0.12">' +
    '<line x1="80" y1="0" x2="80" y2="200" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="160" y1="0" x2="160" y2="200" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="240" y1="0" x2="240" y2="200" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="320" y1="0" x2="320" y2="200" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="400" y1="0" x2="400" y2="200" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="480" y1="0" x2="480" y2="200" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="560" y1="0" x2="560" y2="200" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="640" y1="0" x2="640" y2="200" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="720" y1="0" x2="720" y2="200" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="0" y1="50" x2="800" y2="50" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="0" y1="100" x2="800" y2="100" stroke="var(--primary)" stroke-width="0.5"/>' +
    '<line x1="0" y1="150" x2="800" y2="150" stroke="var(--primary)" stroke-width="0.5"/>' +
    '</g>' +
    '<g class="grid-dots">' +
    '<circle cx="80" cy="50" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="80" cy="100" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="80" cy="150" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="160" cy="50" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="160" cy="100" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="160" cy="150" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="240" cy="50" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="240" cy="100" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="240" cy="150" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="320" cy="50" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="320" cy="100" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="320" cy="150" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="400" cy="50" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="400" cy="100" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="400" cy="150" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="480" cy="50" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="480" cy="100" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="480" cy="150" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="560" cy="50" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="560" cy="100" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="560" cy="150" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="640" cy="50" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="640" cy="100" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="640" cy="150" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="720" cy="50" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="720" cy="100" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '<circle cx="720" cy="150" r="1.5" fill="var(--primary)" opacity="0.2" class="grid-dot"/>' +
    '</g>' +
    '<text x="400" y="115" text-anchor="middle" fill="var(--outline)" font-family="JetBrains Mono, monospace" font-size="9" letter-spacing="0.15em" opacity="0.3" class="grid-label">SERIES 01 — 50 UNITS — BONE</text>' +
    '</svg>';

  // ORB SVG — sphere with 4 orbiting electrons, ring breathing, glow
  var ORB_SVG = '<svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" style="overflow:visible">' +
    '<defs>' +
    '<radialGradient id="sphere-grad" cx="40%" cy="35%" r="50%">' +
    '<stop offset="0%" stop-color="var(--primary)" stop-opacity="1"/>' +
    '<stop offset="40%" stop-color="var(--primary)" stop-opacity="0.9"/>' +
    '<stop offset="100%" stop-color="var(--primary)" stop-opacity="0.5"/>' +
    '</radialGradient>' +
    '<radialGradient id="dot-grad" cx="35%" cy="30%" r="55%">' +
    '<stop offset="0%" stop-color="var(--primary)" stop-opacity="1"/>' +
    '<stop offset="30%" stop-color="var(--primary)" stop-opacity="1"/>' +
    '<stop offset="100%" stop-color="var(--primary)" stop-opacity="0.6"/>' +
    '</radialGradient>' +
    '<filter id="orb-glow" x="-80%" y="-80%" width="260%" height="260%">' +
    '<feGaussianBlur in="SourceGraphic" stdDeviation="6" result="blur"/>' +
    '<feMerge><feMergeNode in="blur"/><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>' +
    '</filter>' +
    '<filter id="orb-core-glow" x="-100%" y="-100%" width="300%" height="300%">' +
    '<feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur"/>' +
    '<feMerge><feMergeNode in="blur"/><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>' +
    '</filter>' +
    '<filter id="orb-shadow" x="-50%" y="-30%" width="200%" height="200%">' +
    '<feGaussianBlur in="SourceAlpha" stdDeviation="5"/>' +
    '<feOffset dy="6" result="shadow"/>' +
    '<feFlood flood-color="var(--bg)" flood-opacity="0.5"/>' +
    '<feComposite in2="shadow" operator="in"/>' +
    '<feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>' +
    '</filter>' +
    '</defs>' +
    '<circle cx="100" cy="100" r="70" stroke="var(--primary)" stroke-width="0.8" opacity="0.45" stroke-dasharray="2 6" class="orbit-ring"/>' +
    '<circle cx="100" cy="100" r="48" stroke="var(--primary)" stroke-width="0.6" opacity="0.35" stroke-dasharray="3 5" class="orbit-ring-mid"/>' +
    '<circle cx="100" cy="100" r="30" stroke="var(--primary)" stroke-width="0.5" opacity="0.3" class="orbit-ring-inner"/>' +
    '<circle cx="100" cy="30" r="6" fill="url(#dot-grad)" filter="url(#orb-glow)" class="orbit-dot"/>' +
    '<circle cx="100" cy="170" r="4.5" fill="url(#dot-grad)" opacity="0.9" filter="url(#orb-glow)" class="orbit-dot-2"/>' +
    '<circle cx="148" cy="100" r="4" fill="url(#dot-grad)" opacity="0.95" filter="url(#orb-glow)" class="orbit-dot-3"/>' +
    '<circle cx="70" cy="100" r="3" fill="url(#dot-grad)" opacity="0.85" filter="url(#orb-glow)" class="orbit-dot-4"/>' +
    '<circle cx="100" cy="100" r="12" fill="var(--primary)" opacity="0.15" filter="url(#orb-core-glow)"/>' +
    '<circle cx="100" cy="100" r="9" fill="url(#sphere-grad)" filter="url(#orb-shadow)"/>' +
    '<circle cx="96" cy="96" r="3.5" fill="var(--primary)" opacity="0.5"/>' +
    '</svg>';

  // ARCH SVG — architectural lines with nodes
  var ARCH_SVG = '<svg viewBox="0 0 1200 120" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full" style="overflow:visible">' +
    '<line x1="0" y1="60" x2="1200" y2="60" stroke="var(--outline-variant)" stroke-width="0.5" opacity="0.35" stroke-dasharray="4 8" class="arch-main"/>' +
    '<line x1="200" y1="30" x2="200" y2="90" stroke="var(--outline-variant)" stroke-width="0.5" opacity="0.25" class="arch-vert"/>' +
    '<line x1="600" y1="20" x2="600" y2="100" stroke="var(--outline-variant)" stroke-width="0.5" opacity="0.35" class="arch-vert"/>' +
    '<line x1="1000" y1="30" x2="1000" y2="90" stroke="var(--outline-variant)" stroke-width="0.5" opacity="0.25" class="arch-vert"/>' +
    '<circle cx="200" cy="60" r="3" fill="none" stroke="var(--primary)" stroke-width="0.75" opacity="0.4" class="arch-node"/>' +
    '<circle cx="600" cy="60" r="4" fill="none" stroke="var(--primary)" stroke-width="0.75" opacity="0.55" class="arch-node"/>' +
    '<circle cx="1000" cy="60" r="3" fill="none" stroke="var(--primary)" stroke-width="0.75" opacity="0.4" class="arch-node"/>' +
    '<text x="600" y="110" text-anchor="middle" fill="var(--primary)" font-family="JetBrains Mono, monospace" font-size="10" letter-spacing="0.25em" opacity="0.5" class="arch-label">UNATTAINABLE COMFORT</text>' +
    '</svg>';

  function animateGrid(container) {
    if (typeof gsap === 'undefined') return;

    var svg = container.querySelector('svg');
    if (!svg) return;
    svg.style.transformStyle = 'preserve-3d';

    // 3D tilt on scroll
    gsap.to(svg, {
      scrollTrigger: {
        trigger: container,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1
      },
      rotateX: 25,
      rotateY: -8,
      transformPerspective: 1000,
      transformOrigin: 'center center',
      ease: 'none'
    });

    // Dots pulse
    container.querySelectorAll('.grid-dot').forEach(function(dot, i) {
      gsap.to(dot, {
        opacity: 0.6,
        attr: { r: 2.5 },
        duration: 1.5,
        delay: i * 0.05,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });
    });

    // Lines draw in on scroll
    container.querySelectorAll('.grid-lines line').forEach(function(line, i) {
      var length = 200;
      try { length = line.getTotalLength() || 200; } catch(e) {}
      gsap.set(line, { strokeDasharray: length, strokeDashoffset: length });
      gsap.to(line, {
        scrollTrigger: { trigger: container, start: 'top 80%', toggleActions: 'play none none none' },
        strokeDashoffset: 0,
        duration: 1.5,
        delay: i * 0.06,
        ease: 'power2.inOut'
      });
    });

    // Label scramble
    var label = container.querySelector('.grid-label');
    if (label) label.setAttribute('data-scramble', '');
  }

  function animateOrb(container) {
    if (typeof gsap === 'undefined') return;

    // Electron 1 — outer ring, slow
    var dot = container.querySelector('.orbit-dot');
    if (dot) {
      gsap.to(dot, {
        rotation: 360,
        transformOrigin: '100px 100px',
        duration: 10,
        repeat: -1,
        ease: 'none'
      });
    }

    // Electron 2 — outer ring, opposite direction
    var dot2 = container.querySelector('.orbit-dot-2');
    if (dot2) {
      gsap.to(dot2, {
        rotation: -360,
        transformOrigin: '100px 100px',
        duration: 8,
        repeat: -1,
        ease: 'none'
      });
    }

    // Electron 3 — middle ring
    var dot3 = container.querySelector('.orbit-dot-3');
    if (dot3) {
      gsap.to(dot3, {
        rotation: 360,
        transformOrigin: '100px 100px',
        duration: 6,
        repeat: -1,
        ease: 'none'
      });
    }

    // Electron 4 — inner ring, fastest
    var dot4 = container.querySelector('.orbit-dot-4');
    if (dot4) {
      gsap.to(dot4, {
        rotation: -360,
        transformOrigin: '100px 100px',
        duration: 3.5,
        repeat: -1,
        ease: 'none'
      });
    }

    // Ring pulses — breathing
    var rings = container.querySelectorAll('.orbit-ring, .orbit-ring-mid, .orbit-ring-inner');
    rings.forEach(function(ring, i) {
      gsap.to(ring, {
        scale: 1.05,
        opacity: 0.55,
        duration: 3.5,
        delay: i * 0.6,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        transformOrigin: '100px 100px'
      });
    });

    // 3D tilt on scroll
    var svg = container.querySelector('svg');
    if (svg) {
      gsap.to(svg, {
        scrollTrigger: {
          trigger: container,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1
        },
        rotateX: 35,
        rotateZ: 10,
        transformPerspective: 600,
        transformOrigin: 'center center',
        ease: 'none'
      });
    }
  }

  function animateArch(container) {
    if (typeof gsap === 'undefined') return;

    var svg = container.querySelector('svg');

    // Main line draws in
    var mainLine = container.querySelector('.arch-main');
    if (mainLine) {
      var len = 1200;
      try { len = mainLine.getTotalLength() || 1200; } catch(e) {}
      gsap.set(mainLine, { strokeDasharray: len, strokeDashoffset: len });
      gsap.to(mainLine, {
        scrollTrigger: { trigger: container, start: 'top 85%', toggleActions: 'play none none none' },
        strokeDashoffset: 0,
        duration: 2,
        ease: 'power2.inOut'
      });
    }

    // Verticals drop in
    container.querySelectorAll('.arch-vert').forEach(function(line, i) {
      gsap.from(line, {
        scrollTrigger: { trigger: container, start: 'top 80%', toggleActions: 'play none none none' },
        scaleY: 0,
        transformOrigin: 'center center',
        duration: 0.8,
        delay: 0.5 + i * 0.2,
        ease: 'power3.out'
      });
    });

    // Nodes scale in
    container.querySelectorAll('.arch-node').forEach(function(node, i) {
      gsap.from(node, {
        scrollTrigger: { trigger: container, start: 'top 80%', toggleActions: 'play none none none' },
        scale: 0,
        opacity: 0,
        transformOrigin: 'center center',
        duration: 0.6,
        delay: 0.8 + i * 0.15,
        ease: 'back.out(3)'
      });
    });

    // 3D perspective on scroll
    if (svg) {
      gsap.to(svg, {
        scrollTrigger: {
          trigger: container,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.5
        },
        rotateX: 15,
        transformPerspective: 1200,
        transformOrigin: 'center center',
        ease: 'none'
      });
    }
  }

  function initSVGScenes() {
    if (typeof gsap === 'undefined') return;

    document.querySelectorAll('[data-svg-scene]').forEach(function(el) {
      var type = el.getAttribute('data-svg-scene');
      el.style.perspective = '1000px';
      el.style.transformStyle = 'preserve-3d';

      switch (type) {
        case 'grid':
          el.innerHTML = GRID_SVG;
          animateGrid(el);
          break;
        case 'orb':
          el.innerHTML = ORB_SVG;
          animateOrb(el);
          break;
        case 'arch':
          el.innerHTML = ARCH_SVG;
          animateArch(el);
          break;
      }
    });
  }

  // ═══════════════════════════════════════════════════
  // THEME TOGGLE — dark/light
  // ═══════════════════════════════════════════════════
  function initTheme() {
    var STORAGE_KEY = 'veyl-theme';

    function getPreferred() {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'dark' || stored === 'light') return stored;
      return 'dark';
    }

    function apply(theme) {
      var html = document.documentElement;
      html.classList.remove('dark', 'light');
      html.classList.add(theme);
      localStorage.setItem(STORAGE_KEY, theme);

      document.querySelectorAll('[data-theme-icon]').forEach(function(el) {
        el.textContent = theme === 'dark' ? 'light_mode' : 'dark_mode';
      });
    }

    apply(getPreferred());

    document.querySelectorAll('[data-theme-toggle]').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var current = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
        apply(current === 'dark' ? 'light' : 'dark');
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // MOBILE MENU
  // ═══════════════════════════════════════════════════
  function initMenu() {
    var toggle = document.getElementById('menu-toggle');
    var menu = document.getElementById('mobile-menu');
    var bar1 = document.getElementById('bar1');
    var bar2 = document.getElementById('bar2');
    var bar3 = document.getElementById('bar3');

    if (!toggle || !menu) return;

    var open = false;

    toggle.addEventListener('click', function() {
      open = !open;
      menu.classList.toggle('open');

      if (bar1) bar1.style.transform = open ? 'rotate(45deg) translate(4px, 4px)' : '';
      if (bar2) bar2.style.opacity = open ? '0' : '1';
      if (bar3) bar3.style.transform = open ? 'rotate(-45deg) translate(4px, -4px)' : '';
      document.body.style.overflow = open ? 'hidden' : '';
    });

    // Also support data-menu-toggle / data-mobile-nav for Shopify templates
    var shopifyToggle = document.querySelector('[data-menu-toggle]');
    var shopifyNav = document.querySelector('[data-mobile-nav]');
    if (shopifyToggle && shopifyNav && shopifyToggle !== toggle) {
      shopifyToggle.addEventListener('click', function() {
        var isOpen = shopifyToggle.getAttribute('aria-expanded') === 'true';
        shopifyToggle.setAttribute('aria-expanded', String(!isOpen));
        shopifyNav.classList.toggle('is-open');
        document.body.style.overflow = isOpen ? '' : 'hidden';
      });
    }
  }

  // ═══════════════════════════════════════════════════
  // NAV SCROLL EFFECT
  // ═══════════════════════════════════════════════════
  function initNavScroll() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    ScrollTrigger.create({
      start: 'top -100',
      onUpdate: function(self) {
        var nav = document.getElementById('nav');
        if (!nav) return;
        if (self.direction === 1 && self.progress > 0) {
          nav.style.background = 'color-mix(in srgb, var(--bg) 85%, transparent)';
          nav.style.backdropFilter = 'blur(12px)';
          nav.style.webkitBackdropFilter = 'blur(12px)';
        } else if (self.scroll() < 100) {
          nav.style.background = 'transparent';
          nav.style.backdropFilter = 'none';
          nav.style.webkitBackdropFilter = 'none';
        }
      }
    });
  }

  // ═══════════════════════════════════════════════════
  // PRODUCT PAGE SPECIFIC
  // ═══════════════════════════════════════════════════
  function initProductPage() {
    if (!document.querySelector('.product-hero') && !document.getElementById('hero-product')) return;

    if (typeof gsap !== 'undefined') {
      // Hero image scale: 1.05 -> 1
      var heroImg = document.getElementById('hero-product');
      if (heroImg) {
        gsap.to(heroImg, { scale: 1, duration: 2, ease: 'power2.out' });
      }

      // Product info fade in
      var productInfo = document.getElementById('product-info');
      if (productInfo) {
        gsap.set(productInfo, { y: 30 });
        gsap.to(productInfo, { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out', delay: 0.3 });
      }

      // Lifestyle image parallax
      var lifestyleImg = document.getElementById('lifestyle-img');
      if (lifestyleImg) {
        gsap.to(lifestyleImg, {
          scrollTrigger: { trigger: lifestyleImg, start: 'top bottom', end: 'bottom top', scrub: 1.5 },
          y: -80, scale: 1.05, ease: 'none'
        });
      }
    }

    // Size selector
    document.querySelectorAll('.size-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        updateVariant();
      });
    });

    // Sticky mobile CTA — show when main CTA scrolls out of view
    var stickyCta = document.getElementById('stickyCta');
    var mainCta = document.querySelector('.product-cta-group');
    if (stickyCta && mainCta) {
      var stickyObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            stickyCta.classList.remove('visible');
          } else {
            stickyCta.classList.add('visible');
          }
        });
      }, { threshold: 0 });
      stickyObserver.observe(mainCta);
    }

    // Color selector with GSAP title crossfade
    document.querySelectorAll('.color-swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        document.querySelectorAll('.color-swatch').forEach(function(s) { s.classList.remove('active'); });
        swatch.classList.add('active');

        var color = swatch.getAttribute('data-color') || 'Bone';
        var label = document.getElementById('color-label');
        if (label) label.textContent = color;

        // Switch hero image to match colorway
        var heroImg = document.getElementById('hero-product');
        var colorMapEl = document.getElementById('colorImageMap');
        if (heroImg && colorMapEl) {
          try {
            var colorMap = JSON.parse(colorMapEl.textContent);
            if (colorMap[color]) {
              if (typeof gsap !== 'undefined') {
                gsap.to(heroImg, { opacity: 0.3, duration: 0.3, ease: 'power2.in', onComplete: function() {
                  heroImg.src = colorMap[color];
                  heroImg.alt = 'The Snoodie — ' + color;
                  gsap.to(heroImg, { opacity: 1, duration: 0.5, ease: 'power2.out' });
                }});
              } else {
                heroImg.src = colorMap[color];
                heroImg.alt = 'The Snoodie — ' + color;
              }
            }
          } catch(e) {}
        }

        var title = document.querySelector('.product-title') || document.querySelector('h1');
        if (title && typeof gsap !== 'undefined') {
          gsap.to(title, {
            opacity: 0, y: -5, duration: 0.2, ease: 'power2.in',
            onComplete: function() {
              title.textContent = 'the snoodie \u2014 ' + color.toLowerCase();
              gsap.to(title, { opacity: 1, y: 0, duration: 0.3, ease: 'power2.out' });
            }
          });
        } else if (title) {
          title.textContent = 'the snoodie \u2014 ' + color.toLowerCase();
        }

        updateVariant();
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // VARIANT SELECTION + AJAX CART
  // ═══════════════════════════════════════════════════
  var _product = null;
  var _selectedOptions = {};

  function getProduct() {
    if (_product) return _product;
    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return null;
    try {
      _product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
    return _product;
  }

  function updateVariant() {
    var product = getProduct();
    if (!product || !product.variants) return;

    // Gather selected options from active swatches/buttons
    var form = document.querySelector('[data-product-form]');

    // Read color from active swatch
    var activeSwatch = document.querySelector('.color-swatch.active');
    if (activeSwatch) {
      var colorPosition = activeSwatch.getAttribute('data-option-position');
      if (colorPosition) {
        _selectedOptions[colorPosition] = activeSwatch.getAttribute('data-option-value') || activeSwatch.getAttribute('data-color');
      } else {
        // Default: color is usually option 1
        _selectedOptions['1'] = activeSwatch.getAttribute('data-option-value') || activeSwatch.getAttribute('data-color');
      }
    }

    // Read size from active size button
    var activeSize = document.querySelector('.size-btn.active');
    if (activeSize) {
      var sizePosition = activeSize.getAttribute('data-option-position');
      if (sizePosition) {
        _selectedOptions[sizePosition] = activeSize.getAttribute('data-option-value') || activeSize.textContent.trim();
      } else {
        // Default: size is usually option 2
        _selectedOptions['2'] = activeSize.getAttribute('data-option-value') || activeSize.textContent.trim();
      }
    }

    // Also read from general [data-option-value].is-active elements (Shopify template pattern)
    if (form) {
      document.querySelectorAll('[data-option-value].is-active').forEach(function(btn) {
        var pos = btn.getAttribute('data-option-position');
        var val = btn.getAttribute('data-option-value');
        if (pos && val) _selectedOptions[pos] = val;
      });
    }

    // Find matching variant
    var matched = null;
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var isMatch = true;
      var keys = Object.keys(_selectedOptions);
      for (var k = 0; k < keys.length; k++) {
        var pos = keys[k];
        if (variant['option' + pos] !== _selectedOptions[pos]) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) {
        matched = variant;
        break;
      }
    }

    if (!matched) return;

    // Update hidden variant ID input
    var variantInput = document.querySelector('[data-variant-id]');
    if (variantInput) variantInput.value = matched.id;

    // Update URL
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}

    // Update button state
    var addBtn = document.querySelector('[data-add-to-cart]');
    var addText = document.querySelector('[data-add-to-cart-text]');
    if (addBtn && addText) {
      if (matched.available) {
        addBtn.disabled = false;
        addText.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addText.textContent = 'Sold Out';
      }
    }

    // Update price display
    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl && matched.price) {
      priceEl.textContent = '$' + (matched.price / 100).toFixed(2);
    }

    // Update ProductPrice element (clear price display)
    var productPriceEl = document.getElementById('ProductPrice');
    if (productPriceEl && matched.price) {
      productPriceEl.textContent = (matched.price / 100).toLocaleString('en-IN', {style: 'currency', currency: 'INR', minimumFractionDigits: 0});
    }

    // Update sticky CTA price
    var stickyPrice = document.getElementById('stickyPrice');
    if (stickyPrice && matched.price) {
      stickyPrice.textContent = (matched.price / 100).toLocaleString('en-IN', {style: 'currency', currency: 'INR', minimumFractionDigits: 0});
    }

    // Update Buy Now button text with price
    document.querySelectorAll('[data-buy-now]').forEach(function(btn) {
      var span = btn.querySelector('span');
      if (span && matched) {
        span.textContent = 'Buy Now \u2014 ' + (matched.price / 100).toLocaleString('en-IN', {style: 'currency', currency: 'INR', minimumFractionDigits: 0});
      }
    });

    // Update main product image
    var mainImage = document.getElementById('ProductMainImage') || document.getElementById('hero-product');
    if (matched.featured_image && mainImage) {
      mainImage.src = matched.featured_image.src;
      if (mainImage.srcset !== undefined) mainImage.srcset = '';
    }
  }

  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var product = getProduct();
    if (!product) return;

    // Initialize selected options from first available variant
    if (product.variants && product.variants.length > 0) {
      var firstVariant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) { firstVariant = product.variants[i]; break; }
      }
      if (!firstVariant) firstVariant = product.variants[0];

      if (product.options) {
        for (var idx = 0; idx < product.options.length; idx++) {
          _selectedOptions[idx + 1] = firstVariant['option' + (idx + 1)];
        }
      }
    }

    // Shopify-style option buttons
    var optionButtons = form.querySelectorAll('[data-option-value]');
    optionButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var position = btn.getAttribute('data-option-position');
        var value = btn.getAttribute('data-option-value');
        if (position && value) {
          _selectedOptions[position] = value;

          // Update active states
          var siblings = form.querySelectorAll('[data-option-position="' + position + '"]');
          siblings.forEach(function(s) { s.classList.remove('is-active'); });
          btn.classList.add('is-active');
        }
        updateVariant();
      });
    });

    // Thumbnail clicks
    var thumbnails = document.querySelectorAll('[data-thumbnail]');
    var mainImage = document.getElementById('ProductMainImage') || document.getElementById('hero-product');
    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var imageUrl = thumb.getAttribute('data-image-url');
        if (mainImage && imageUrl) {
          mainImage.src = imageUrl;
          if (mainImage.srcset !== undefined) mainImage.srcset = '';
        }
        thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // AJAX ADD TO CART
  // ═══════════════════════════════════════════════════
  function initAjaxCart() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    // Buy Now — direct to checkout
    document.querySelectorAll('[data-buy-now]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantInput = document.querySelector('[data-variant-id]');
        if (!variantInput) return;
        var variantId = variantInput.value;
        window.location.href = '/cart/' + variantId + ':1';
      });
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var variantInput = form.querySelector('[data-variant-id]');
      var variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;

      var addBtn = form.querySelector('[data-add-to-cart]');
      var addText = form.querySelector('[data-add-to-cart-text]');

      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function() {
        if (addText) addText.textContent = 'Added';
        updateCartCount();
        setTimeout(function() {
          if (addBtn) addBtn.disabled = false;
          if (addText) addText.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function() {
        if (addBtn) addBtn.disabled = false;
        if (addText) addText.textContent = 'Add to Cart';
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // CART COUNT UPDATE
  // ═══════════════════════════════════════════════════
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function() {});
  }

  // ═══════════════════════════════════════════════════
  // CART QUANTITY +/- BUTTONS
  // ═══════════════════════════════════════════════════
  function initCartQuantity() {
    document.querySelectorAll('[data-quantity-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('[data-quantity-input]');
        if (!input) return;
        var newVal = Math.max(0, parseInt(input.value) - 1);
        input.value = newVal;
        var key = btn.getAttribute('data-key');
        if (key) updateCartItem(key, newVal);
      });
    });

    document.querySelectorAll('[data-quantity-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('[data-quantity-input]');
        if (!input) return;
        var newVal = parseInt(input.value) + 1;
        input.value = newVal;
        var key = btn.getAttribute('data-key');
        if (key) updateCartItem(key, newVal);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      window.location.reload();
    })
    .catch(function() {});
  }

  // ═══════════════════════════════════════════════════
  // ACCORDION TOGGLE
  // ═══════════════════════════════════════════════════
  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var accordion = trigger.closest('[data-accordion]');
        if (!accordion) return;
        var content = accordion.querySelector('[data-accordion-content]');
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        trigger.setAttribute('aria-expanded', String(!isExpanded));
        if (content) content.classList.toggle('is-open');

        // Swap +/- icon if present
        var icon = trigger.querySelector('[data-accordion-icon]');
        if (icon) {
          icon.textContent = isExpanded ? '+' : '\u2013';
        }
      });
    });
  }

  // ═══════════════════════════════════════════════════
  // LOGIN / RECOVER PASSWORD TOGGLE
  // ═══════════════════════════════════════════════════
  function initLoginForm() {
    var showRecover = document.getElementById('RecoverPassword');
    var hideRecover = document.getElementById('HideRecoverPassword');
    var recoverForm = document.getElementById('RecoverPasswordForm');

    if (showRecover && recoverForm) {
      showRecover.addEventListener('click', function(e) {
        e.preventDefault();
        recoverForm.style.display = 'block';
        if (showRecover.closest('form')) {
          showRecover.closest('form').style.display = 'none';
        }
      });
    }

    if (hideRecover && recoverForm) {
      hideRecover.addEventListener('click', function(e) {
        e.preventDefault();
        recoverForm.style.display = 'none';
        var loginFormEl = document.querySelector('.main-login form:not(#RecoverPasswordForm form)');
        if (loginFormEl) loginFormEl.style.display = 'block';
      });
    }

    if (window.location.hash === '#recover' && recoverForm) {
      recoverForm.style.display = 'block';
    }
  }

  // ═══════════════════════════════════════════════════
  // COUNTER ANIMATION
  // ═══════════════════════════════════════════════════
  function animateCounter(el, target, duration) {
    if (typeof gsap === 'undefined') return;
    duration = duration || 1.5;
    var obj = { val: 0 };
    gsap.to(obj, {
      val: target,
      duration: duration,
      ease: 'power2.out',
      onUpdate: function() {
        el.textContent = Math.floor(obj.val).toString();
      }
    });
  }

  // ═══════════════════════════════════════════════════
  // COUNTER ELEMENTS — [data-counter]
  // ═══════════════════════════════════════════════════
  function initCounters() {
    document.querySelectorAll('[data-counter]').forEach(function(el) {
      var target = parseInt(el.getAttribute('data-counter') || el.textContent, 10);
      if (isNaN(target)) return;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(el);
          animateCounter(el, target);
        });
      }, { threshold: 0.5 });

      observer.observe(el);
    });
  }

  // ═══════════════════════════════════════════════════
  // MASTER INIT
  // ═══════════════════════════════════════════════════
  initLoader(function() {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }
    initTheme();
    initMenu();
    initNavScroll();
    initReveals();
    initSplitText();
    initClipReveals();
    init3DTilt();
    init3DScrollDepth();
    init3DSections();
    initMagnetic();
    initCursor();
    initNavEntrance();
    initTextSlides();
    initImageHover();
    initTextScramble();
    initSVGScenes();
    initCounters();
    initProductPage();
    initProductForm();
    initAjaxCart();
    initAccordions();
    initCartQuantity();
    initLoginForm();
  });
})();
